import { useEffect, useState } from 'react';

import { appAPI } from '../../API/api';
import style from './DownLoadPage.module.scss';

function DownLoadPage() {
  const [link, setLink] = useState('');
  useEffect(() => {
    const getLastVersion = async () => {
      try {
        const res = await appAPI.getLastVersion();
        setLink(res.url);
        console.log(res);
      } catch (error) {
        console.log(error);
      }
    };

    getLastVersion();
  }, []);

  return (
    <div className={style.downloadPage}>
      <div className={style.app__right}>
        <div className={style.application}>
          <div className={style.application__image}>
            <img
              src="https://lbw.plus/image/gif-lbw.gif"
              alt="main screen lbw"
              className={style.application__img}
            />
          </div>
          <div className={style.application__btn_container}>
            <a
              href={link}
              className={`${style.link} ${style.application__link} ${style.application__link__orange}`}
            >
              Download
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DownLoadPage;
